import React from 'react';

const InfoIcon = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4207_32754"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="16"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.6153 13.006H6.90773C6.59815 13.006 6.34816 12.73 6.34816 12.3908C6.34816 12.0516 6.59815 11.7755 6.90773 11.7755L7.80884 11.6245V7.50463L6.90773 7.34533C6.59815 7.34533 6.34816 7.0693 6.34816 6.73009C6.34816 6.39089 6.59815 6.11486 6.90773 6.11486H10.5616C10.6735 6.11486 10.7099 6.07092 10.7258 6.03521C10.7215 6.05581 10.7157 6.07504 10.7157 6.13134V11.6245L11.6153 11.7755C11.9249 11.7755 12.1763 12.0516 12.1763 12.3908C12.1763 12.73 11.9249 13.006 11.6153 13.006ZM7.80884 2.01149H9.23319C9.24336 2.01149 9.25208 2.006 9.26225 2.006C9.27243 2.006 9.28115 2.01149 9.29132 2.01149H10.7157V3.30238C10.7171 3.33259 10.7331 3.35731 10.7331 3.38615C10.7331 3.41636 10.7171 3.44108 10.7157 3.46992V4.75806H9.31022C9.29278 4.75943 9.27824 4.76767 9.26225 4.76767C9.24481 4.76767 9.23028 4.75943 9.21429 4.75806H7.80884V3.46855C7.80594 3.43971 7.78995 3.41636 7.78995 3.38615C7.78995 3.35731 7.80594 3.33259 7.80884 3.30375V2.01149ZM8.99999 0C4.32315 0 0.533203 3.582 0.533203 8C0.533203 12.418 4.32315 16 8.99999 16C13.6758 16 17.4668 12.418 17.4668 8C17.4668 3.582 13.6758 0 8.99999 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4207_32754)">
        <rect
          x="-0.0927734"
          y="-0.157715"
          width="18"
          height="17"
          fill="#A8AAB7"
        />
      </g>
    </svg>
  );
};

export default InfoIcon;
